import clsx from 'clsx'

const getBackgroundColorProgress = (percentage) => {
    if (percentage <= 40) {
        return 'bg-green-600'
    } else if (percentage > 40 && percentage <= 80) {
        return 'bg-yellow-400'
    } else if (percentage > 80 && percentage <= 100) {
        return 'bg-red-500'
    } else {
        return 'bg-slate-500'
    }
}

export const TABLE_LEAVE_ANALYTICS = {
    name: 'List Leave Analytics',
    column: [
        {
            name: 'Name',
            key: 'employee_name',
            className: 'font-medium',
            render: ({ item }) => (
                <div className='flex flex-col gap-1'>
                    <div className='font-semibold capitalize'>{item?.employee_name}</div>
                    <div>NIP: {item?.nip}</div>
                </div>
            ),
        },
        {
            name: 'Job Title',
            key: 'job_title',
        },
        {
            name: 'Kategori Cuti',
            key: 'leave_category',
            className: 'font-semibold',
        },
        {
            name: 'Kuota Cuti',
            key: 'quota',
            render: ({ value }) => (value ? `${value} Hari` : '-'),
        },
        {
            name: 'Kuota Terpakai',
            key: 'used_quota',
            render: ({ value }) => (value ? `${value} Hari` : '-'),
        },
        {
            name: 'Sisa Kuota',
            key: 'remaining_quota',
            className: 'font-semibold',
            render: ({ value }) => (value ? `${value} Hari` : '-'),
        },
        {
            name: 'Penggunaan Cuti (%)',
            key: 'percentage',
            render: ({ value = 0 }) => (
                <div className='flex items-center gap-1 pr-5'>
                    <div className='flex-1 h-3 bg-neutral-30 rounded-full overflow-hidden'>
                        {/* progress */}
                        <div
                            className={clsx('h-full rounded-full', getBackgroundColorProgress(value))}
                            style={{ width: `${value}%` }}
                        />
                    </div>
                    <div className='w-8 text-end font-semibold'>{value}%</div>
                </div>
            ),
        },
    ],
}
